import { nanoid } from "nanoid";
import { isSingleConnectionNode } from "../components/nodes/ActionNode/utils";
import { type FEActionResourceType } from "../constants/resourceTypes";
import type { NodeType } from "../types/nodes";

export function generateTempNode(baseActionResourceType: FEActionResourceType) {
  const tempNodeId = `temp-${nanoid()}`;
  return {
    id: tempNodeId,
    type: "tempNode" as NodeType.TempNode,
    data: {
      baseActionResourceType,
    },
    position: {
      x: 0,
      y: 0,
    },
    hidden: isSingleConnectionNode(baseActionResourceType),
    draggable: false,
  };
}
